import { getDraftedApp,getDraftedDoc } from './states';

export const services = {
  getDraftedApp,getDraftedDoc
};
